var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"tag",attrs:{"to":{name: 'News', query: { topic: _vm.item.slug }}}},[_vm._v(_vm._s(_vm.item.name)+" "),_c('span',[_vm._v(_vm._s(_vm.item.count))]),_c('i',{staticClass:"fa-solid fa-chevron-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }